import { CustomFormsState } from './reducers';

export const getCustomForms = ({ pages: { customForms } }) => customForms as CustomFormsState;
